// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useRef } from 'react';

import type { FieldMapFromIframe } from '../../../../../../../../common/types/field';
import { useCurrentFormState } from '../../../../../../../../controllers/issue-adjustments/hooks/use-current-form-state';
import { useViewType } from '../../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { filterFieldsChangesBasedOnScopes } from '../../utils/filter-based-on-scopes/form-data';

export const useFilterFieldChangesBasedOnScope = (
	moduleScopes: readonly string[],
): ((fieldChanges: FieldMapFromIframe) => FieldMapFromIframe) => {
	const { currentFormState } = useCurrentFormState();
	const currentFormStateRef = useRef(currentFormState);
	const viewType = useViewType();

	/**
	 * We want to have an up-to-date data when this hook's
	 * returned function is being called in useSubmit callback function
	 * thats why we keep it in a ref object
	 */
	currentFormStateRef.current = currentFormState;

	return useCallback(
		(fieldChanges: FieldMapFromIframe) =>
			filterFieldsChangesBasedOnScopes(
				fieldChanges,
				currentFormStateRef.current,
				viewType,
				moduleScopes,
			),
		[moduleScopes, viewType],
	);
};
